import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";

import { APIOptions, PrimeReactProvider } from "primereact/api";

import { StoreProvider } from "./app/components/Core/StoreProvider/StoreProvider.tsx";
import { router } from "./app/components/Routes/Routes.tsx";
import { useAuthProvider } from "./auth/hooks/auth-provider.tsx";

import "./app/layout/sass/main.scss";

import { SharedDialogProvider } from "./app/components/Shared/Components/Dialogs/SharedDialog";

const { AuthProvider } = useAuthProvider();

const rootElement = document.getElementById("root");
const reactRoot = ReactDOM.createRoot(rootElement as HTMLElement);

const primeReactProviderValue: Partial<APIOptions> = {
  appendTo: document.body,
  ripple: true,
  unstyled: false,
};

reactRoot.render(
  <StrictMode>
    <AuthProvider>
      <PrimeReactProvider value={primeReactProviderValue}>
        <StoreProvider>
          <SharedDialogProvider>
            <RouterProvider router={router} />
          </SharedDialogProvider>
        </StoreProvider>
      </PrimeReactProvider>
    </AuthProvider>
  </StrictMode>,
);
